/** Decorpot marketing zones for ERP location cities. */
export const ZONES = ['North', 'South', 'East', 'West'];

export const CITY_ZONE = {
    Ahmedabad: 'West',
    Bangalore: 'South',
    Bhubaneshwar: 'East',
    Chennai: 'South',
    Coimbatore: 'South',
    Hubli: 'South',
    Hyderabad: 'South',
    Indore: 'West',
    Jaipur: 'North',
    Kochi: 'South',
    Kolkata: 'East',
    Lucknow: 'North',
    Mumbai: 'West',
    Mysore: 'South',
    NCR: 'North',
    Nagpur: 'West',
    Patna: 'East',
    Pune: 'West',
    Raipur: 'East',
    Ranchi: 'East',
    Surat: 'West',
    Vijayawada: 'South',
    Visakhapatnam: 'South',
};

export function zoneForCity(cityName) {
    if (!cityName) return null;
    return CITY_ZONE[String(cityName).trim()] || null;
}

export function citiesMatchingZones(allCityNames, selectedZones) {
    const names = Array.isArray(allCityNames) ? allCityNames : [];
    if (!selectedZones?.length) return names;
    return names.filter((name) => selectedZones.includes(CITY_ZONE[name]));
}

export function campaignMatchesZones(campaign, selectedZones) {
    if (!selectedZones?.length) return true;
    const tags = campaign.adsetCities?.length
        ? campaign.adsetCities
        : (campaign.cities?.length ? campaign.cities : []);
    if (!tags.length) return false;
    return tags.some((tag) => selectedZones.includes(CITY_ZONE[tag]));
}

export function mergeDailyTrends(trendPayloads) {
    const byDate = new Map();
    (trendPayloads || []).forEach((payload) => {
        const rows = Array.isArray(payload)
            ? payload
            : Array.isArray(payload?.daily) ? payload.daily : [];
        rows.forEach((row) => {
            const date = String(row.date || row.day || '').slice(0, 10);
            if (!date) return;
            const prev = byDate.get(date) || {
                date,
                spend: 0,
                clicks: 0,
                impressions: 0,
                leadCount: 0,
                currency: row.currency || 'INR',
            };
            prev.spend += Number(row.spend) || 0;
            prev.clicks += Number(row.clicks) || 0;
            prev.impressions += Number(row.impressions) || 0;
            prev.leadCount += Number(row.leadCount ?? row.leads) || 0;
            if (row.currency) prev.currency = row.currency;
            byDate.set(date, prev);
        });
    });
    return [...byDate.values()].sort((a, b) => a.date.localeCompare(b.date));
}
